import React from 'react'
import { withPrefix } from 'gatsby';
import { ExclamationCircle } from '../../../../svg/exclamation_circle'
import { Notes } from '../../../../svg/notes'
import s from './informe-de-coyuntura-cuatrimestral.module.css'

const InformeDeCoyunturaCuatrimestral = () => {
  return (
    <div className={'containerWrap'}>
      <div className={`flex direction-column direction-row@lg`}>
        <div className={`w-100 w-50@lg order-1 order-1@lg`}>
          <h2 className="tw-mt-16@lg tw-mb-2 tw-mb-4@lg center left@lg font-family-secondary c-turquoise-0 fw-7 tw-f-24 tw-f-24@lg">
            Informe de Coyuntura Cuatrimestral
          </h2>

          <div className='tw-mb-4 tw-mb-4@lg center left@lg'>
            <p className='font-family-primary c-gray--4 fw-0 tw-f-16 tw-f-16@lg'>
              Ponemos a tu disposición el boletín de coyuntura cuatrimestral en donde podrás 
              encontrar información económica financiera y de inversiones. A través de este 
              Informe, podrás conocer la situación del mercado financiero, las perspectivas 
              económicas financieras y la estrategia de <span className="b">inversión de Prima AFP </span> 
              para los próximos meses.{' '}
            </p>
          </div>

          <div className="flex items-center">
            <div className="w-100 w-70@lg font-family-primary brad-4 border border-2 tw-p-6 tw-pr-20 tw-f-16 tw-f-16@lg f-4 bg-white">
              Descarga nuestros reportes ingresando a tu Agencia Virtual con
              tu documento de identidad y tu clave web.
            </div>
            <div className={`brad-pill border border-2 tw-p-2 tw-pb-1 bg-white ${s.iconArrow}`}>
              <Notes fill={'#00CCCC'} width={'40'} height={'40'} />
            </div>
          </div>
        </div>

        <div className={`w-100 w-50@lg order-2 order-2@lg`}>
          <img
            src={withPrefix('/images/woman-and-graphics.svg')}
            alt="woman-and-graphics"
            className={`${s.imagenBox3}`}
          />

          <div
            className={`w-auto w-70@lg border border-turquoise-0 brad-4 bg-turquoise-1 tw-p-4 font-family-primary tw-f-16 tw-f-16@lg tw-mb-8 tw-mb-8@lg ${s.displayMobileIcon}`}
          >
            <div className={`flex`}>
              <div className={`tw-mr-2`}>
                <ExclamationCircle fill={'#00CCCC'} />
              </div>
              <div>
                Descarga nuestros reportes ingresando a tu cuenta personal
                con tu documento de identidad y tu clave web.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
};

export default InformeDeCoyunturaCuatrimestral;
